// extracted by mini-css-extract-plugin
module.exports = {"introContent":"RelatedProducts_introContent__JxRV4","grid":"RelatedProducts_grid__mMGLT","column":"RelatedProducts_column___9Uan","cols-half":"RelatedProducts_cols-half__9pB_g","cols-thirds":"RelatedProducts_cols-thirds__Yb_X9"};
module.exports.__checksum = "1fb2906d760c"
